import React, { useEffect, useState } from "react";
import { adminLotteries, adminResults } from "../../adminApi";
import { Loader2, RefreshCw } from "lucide-react";
import axios from "axios";

export default function AdminLotteriesResults({ resultsTab = false }) {
  const [data, setData] = useState({ lotteries: [], day: "" });
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      const r = await adminLotteries();
      setData(r);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const triggerScraper = async () => {
    setRefreshing(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/refresh-results`);
      await load();
    } catch {} finally {
      setRefreshing(false);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-2xl font-extrabold text-gray-900">{resultsTab ? "Resultados" : "Loter\u00edas"}</h2>
          <p className="text-sm text-gray-500 mt-1">{data.day && `Fecha: ${data.day}`}</p>
        </div>
        <button onClick={triggerScraper} disabled={refreshing} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500 text-white text-sm font-bold hover:bg-emerald-600 disabled:opacity-60">
          <RefreshCw className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`} /> Forzar scraper
        </button>
      </div>

      {loading ? (
        <p className="text-gray-500"><Loader2 className="w-5 h-5 animate-spin inline" /> Cargando...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {(data.lotteries || []).map((l) => (
            <div key={l.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="font-bold text-gray-900">{l.name}</div>
                <span className="text-[10px] text-gray-500">{l.draws.length} sorteos</span>
              </div>
              <ul className="space-y-1.5 text-xs">
                {l.draws.map((d) => {
                  const r = (l.latest && l.latest[d.id]) || {};
                  return (
                    <li key={d.id} className="flex items-center justify-between">
                      <span className="text-gray-700">{d.name} <span className="text-gray-400">{d.time}</span></span>
                      <div className="flex items-center gap-1">
                        {(r.numbers || []).slice(0, 4).map((n, i) => (
                          <span key={i} className="inline-flex items-center justify-center w-7 h-7 rounded bg-green-500 text-white font-bold text-xs">{n}</span>
                        ))}
                        {(!r.numbers || !r.numbers.length) && <span className="text-gray-400 italic text-[11px]">pendiente</span>}
                        {r.source && <span className={`ml-1 text-[9px] px-1.5 py-0.5 rounded ${r.source === "scrape" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{r.source}</span>}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
